export default __webpack_public_path__ + "static/media/bgSub.2f7e402b.png";